import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Divider } from "@mui/material";
import Header from "./Header";
import Footer from "./Footer";

const Layout = () => {
  return (
    <>
      <Header />
      <Box height={64} />
      <Box minHeight="calc(100vh - 64px)" py={4}>
        <Outlet />
      </Box>
      <Divider />
      <Footer />
    </>
  );
};

export default Layout;
